import { apiSlice } from '../../app/services/apiSlice';

const CUSTOMERS_URL = 'customer/customer';

export const customersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addCustomer: builder.mutation({
      query: (data) => ({
        url: `${CUSTOMERS_URL}`,
        method: 'POST',
        body: { ...data },
      }),
    }),
    updateCustomer: builder.mutation({
      query: (data) => ({
        url: `${CUSTOMERS_URL}`,
        method: 'PUT',
        body: { ...data },
      }),
    }),
    getAllCustomers: builder.query({
      query: (params) => ({
        url: `${CUSTOMERS_URL}`,
        params: { ...params },
      }),
    }),
    getSingleCustomer: builder.query({
      query: (id) => ({
        url: `${CUSTOMERS_URL}/${id}`,
      }),
    }),
    getCustomers: builder.mutation({
      query: (params) => ({
        url: `${CUSTOMERS_URL}`,
        params: { ...params },
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.objectData?.content?.map(
          (customer) => {
            return {
              ...customer,
              id: customer.id,
              title: `${customer?.firstName || ''} ${
                customer?.lastName || ''
              } ${customer?.companyName ? `(${customer?.companyName})` : ''}`,
            };
          },
        );
        return responseData || {};
      },
    }),
    getCustomerEmailReminderList: builder.query({
      query: (id) => ({
        url: `${CUSTOMERS_URL}/${id}`,
      }),
    }),
  }),
});

export const {
  useAddCustomerMutation,
  useGetCustomersMutation,
  useGetAllCustomersQuery,
  useGetSingleCustomerQuery,
  useUpdateCustomerMutation,
  useGetCustomerEmailReminderListQuery
} = customersApiSlice;
